import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@utils';

const headingVariants = cva(cn('font-heading'), {
  variants: {
    variant: {
      h1: 'text-inherit text-4xl md:text-5xl lg:text-6xl',
      h2: 'text-inherit text-4xl md:text-5xl lg:text-6xl',
      h3: 'text-inherit text-2xl md:text-3xl',
      h4: 'text-inherit text-xl',
      h5: 'text-inherit text-lg',
    },
  },
  defaultVariants: {
    variant: 'h1',
  },
});

function Heading({ className, children, variant = 'h1' }: HeadingProps) {
  const classes = cn(headingVariants({ variant, className }));

  return (
    <>
      {variant === 'h1' && <h1 className={classes}>{children}</h1>}
      {variant === 'h2' && <h2 className={classes}>{children}</h2>}
      {variant === 'h3' && <h3 className={classes}>{children}</h3>}
      {variant === 'h4' && <h4 className={classes}>{children}</h4>}
    </>
  );
}

Heading.displayName = 'Heading';

export type HeadingProps = VariantProps<typeof headingVariants> & {
  className?: string;
  children: React.ReactNode;
};

export { Heading, headingVariants };
